import type { VueConstructor } from 'vue'
import _ from 'lodash'

// 重命名directive, 需要特殊的方式
export function renameDirective(Vue: VueConstructor, fn: () => void, from: string, to: string) {
    const oldPath = `options.directives.${from}`
    const newPath = `options.directives.${to}`
    const originLoadingDirective = _.get(Vue, oldPath)
    fn()
    const newLoadingDirective = _.get(Vue, oldPath)
    _.set(Vue, newPath, newLoadingDirective)
    if (originLoadingDirective) {
        _.set(Vue, oldPath, originLoadingDirective)
    }
}
